import React from 'react';
import { MuiOtpInput } from 'mui-one-time-password-input';
import { otpInputFieldStyles } from './otpInput.style'; // Import the styles
import { isNumberRegex } from '../../../../lib/constants/regexConstant';

// Helper function to check if a character is numeric
const matchIsNumeric = (value) => {
  return isNumberRegex.test(value); // Returns true if value is a single digit (0-9)
};

// Initial value is set to an empty string handelChange update the new value in the state and the validateChar prop is set to the matchIsNumeric function
const OtpInputField = ({ otpValue, setOtpValue }) => {
  const handleChange = (newValue) => {
    setOtpValue(newValue);
  };

  const validateChar = (value) => {
    return matchIsNumeric(value); // Validate if the character is numeric
  };

  return (
    <MuiOtpInput
      autoFocus
      value={otpValue}
      onChange={handleChange}
      validateChar={validateChar} // Set the validateChar prop for character validation
      TextFieldsProps={{ 
        type: 'number',
        inputMode: 'numeric',
        placeholder: '___',
        inputProps: {
          inputMode: 'numeric',
        }
      }}
      length={6} // Set length to 6 for 6 input boxes
      sx={otpInputFieldStyles} // Apply the imported styles
      
    />
  );
};

export default React.memo(OtpInputField);
